function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.01 512.01",
    style: {
      enableBackground: "new 0 0 512.01 512.01"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-base_00000027569791829998962360000016697435614286852497_",
    gradientUnits: "userSpaceOnUse",
    x1: -678.6914,
    y1: 6127.4854,
    x2: -679.495,
    y2: 6126.6841,
    gradientTransform: "matrix(480.0036 0 0 -495.9987 326214.75 3039304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#FF3346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#FF0D8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "shape-base",
    style: {
      fill: "url(#shape-base_00000027569791829998962360000016697435614286852497_)"
    },
    d: "M485.903,171.728 c-10.782-25.935-32.619-53.934-49.767-62.783c13.956,27.36,22.034,54.806,25.12,75.289c0,0.04,0.016,0.14,0.049,0.413 c-28.052-69.918-75.617-98.111-114.458-159.498c-1.961-3.104-3.928-6.216-5.844-9.497c-0.975-1.675-1.887-3.387-2.731-5.132 c-1.614-3.116-2.858-6.409-3.709-9.813c0.012-0.334-0.232-0.622-0.564-0.665c-0.152-0.044-0.314-0.044-0.466,0 c-0.035,0.012-0.087,0.053-0.124,0.067c-0.055,0.022-0.429,0.244-0.412,0.224c-62.318,36.497-83.125,103.75-85.068,137.529 c-24.885,1.711-48.678,10.879-68.276,26.31c-2.052-1.733-4.197-3.353-6.426-4.852c-5.654-19.782-5.895-40.72-0.696-60.627 c-25.484,11.604-45.306,29.946-59.716,46.142h-0.115c-9.834-12.456-9.141-53.546-8.58-62.125c-0.118-0.532-7.336,3.747-8.282,4.392 c-8.678,6.194-16.791,13.144-24.244,20.769c-8.481,8.6-16.23,17.893-23.166,27.781c0,0.012-0.007,0.027-0.011,0.039 c0-0.013,0.007-0.027,0.011-0.039c-15.952,22.606-27.266,48.149-33.287,75.154c-0.119,0.538-0.219,1.095-0.334,1.637 c-0.467,2.184-2.147,13.11-2.441,15.484c-0.023,0.183-0.033,0.358-0.055,0.541c-2.173,11.296-3.518,22.735-4.026,34.227 c0,0.423-0.026,0.842-0.026,1.267C8.265,400.957,119.336,512.01,256.342,512.01c122.7,0,224.579-89.072,244.524-206.07 c0.42-3.175,0.757-6.367,1.127-9.57C506.924,253.83,501.446,209.118,485.903,171.728z M199.972,365.89 c1.16,0.554,2.25,1.16,3.442,1.692c0.05,0.034,0.118,0.072,0.168,0.103C202.369,367.106,201.166,366.507,199.972,365.89z M461.324,184.708l-0.033-0.241c0.012,0.088,0.028,0.18,0.041,0.267L461.324,184.708z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "body-outer-ring_00000023282595785137162540000011968843662847919548_",
    cx: -678.3328,
    cy: 6130.6401,
    r: 1.3213,
    gradientTransform: "matrix(384.0014 0 0 -390.468 260923.6406 2393927.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFBD44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#FF3450"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#FF027B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#FF0083"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body-outer-ring",
    style: {
      fill: "url(#body-outer-ring_00000023282595785137162540000011968843662847919548_)"
    },
    d: " M485.903,171.728c-10.782-25.935-32.619-53.934-49.767-62.783c13.956,27.36,22.034,54.806,25.12,75.289 c0-0.06,0.011,0.05,0.037,0.233c0.012,0.088,0.028,0.18,0.041,0.267c23.406,63.453,10.655,127.978-7.72,167.407 c-28.427,61.007-97.254,123.531-204.982,120.481C132.239,469.327,29.7,382.965,10.559,269.852c-3.488-17.837,0-26.894,1.755-41.377 c-2.138,11.165-2.952,14.39-4.026,34.227c0,0.423-0.026,0.842-0.026,1.267C8.265,400.957,119.336,512.01,256.342,512.01 c122.7,0,224.579-89.072,244.524-206.07c0.42-3.175,0.757-6.367,1.127-9.57C506.924,253.83,501.446,209.118,485.903,171.728z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "body-outer-ring-shadow_00000096046357773761222090000015547138260334618799_",
    cx: -678.7749,
    cy: 6130.0981,
    r: 1.3213,
    gradientTransform: "matrix(393.6014 0 0 -390.468 267417.7812 2393877.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#AF0611"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#CE1223",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#FD243B",
      stopOpacity: 0.34
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF304B",
      stopOpacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#FF3450",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body-outer-ring-shadow",
    style: {
      fill: "url(#body-outer-ring-shadow_00000096046357773761222090000015547138260334618799_)"
    },
    d: " M485.903,171.728c-10.782-25.935-32.619-53.934-49.767-62.783c13.956,27.36,22.034,54.806,25.12,75.289 c0-0.06,0.011,0.05,0.037,0.233c0.012,0.088,0.028,0.18,0.041,0.267c23.406,63.453,10.655,127.978-7.72,167.407 c-28.427,61.007-97.254,123.531-204.982,120.481C132.239,469.327,29.7,382.965,10.559,269.852c-3.488-17.837,0-26.894,1.755-41.377 c-2.138,11.165-2.952,14.39-4.026,34.227c0,0.423-0.026,0.842-0.026,1.267C8.265,400.957,119.336,512.01,256.342,512.01 c122.7,0,224.579-89.072,244.524-206.07c0.42-3.175,0.757-6.367,1.127-9.57C506.924,253.83,501.446,209.118,485.903,171.728z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tail-tip_00000033348937748295745630000000484682573222251967_",
    cx: -674.5927,
    cy: 6144.0962,
    r: 1.4451,
    gradientTransform: "matrix(115.236 0 0 -195.642 78042.3906 1202019.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#FF9800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "tail-tip",
    style: {
      fill: "url(#tail-tip_00000033348937748295745630000000484682573222251967_)"
    },
    d: "M365.346,200.886 c0.541,0.38,1.032,0.758,1.541,1.135c-6.226-11.05-13.979-21.166-23.03-30.051C266.743,94.865,333.043,0.322,333.061,0.302 c-62.318,36.497-83.184,103.778-85.127,137.556c2.89-0.2,5.773-0.443,8.714-0.443C303.152,137.416,343.656,162.985,365.346,200.886 L365.346,200.886z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "globe-base_00000080184773766387035040000015885096926909371788_",
    cx: -677.5864,
    cy: 6138.3994,
    r: 1.0323,
    gradientTransform: "matrix(213.483 0 0 -233.9799 144848.2969 1436665.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#008EE9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#A059FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DF36EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "globe-base",
    style: {
      fill: "url(#globe-base_00000080184773766387035040000015885096926909371788_)"
    },
    d: "M256.804,216.282 c-0.406,6.171-22.208,27.451-29.832,27.451c-70.544,0-81.995,42.669-81.995,42.669c3.125,35.933,28.14,65.523,58.437,81.18 c1.382,0.714,2.781,1.359,4.181,1.997c2.4,1.063,4.83,2.056,7.287,2.979c10.388,3.678,21.269,5.776,32.28,6.226 c123.644,5.799,147.599-147.814,58.369-192.422c22.851-3.974,46.57,5.216,59.816,14.521 c-21.69-37.898-62.194-63.468-108.697-63.468c-2.942,0-5.823,0.243-8.714,0.443c-24.885,1.711-48.678,10.879-68.276,26.31 c3.782,3.2,8.052,7.478,17.047,16.339C213.535,197.092,256.712,214.267,256.804,216.282L256.804,216.282z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "globe-shadow_00000116931814237368977270000009253733651089027476_",
    cx: -676.9322,
    cy: 6139.1958,
    r: 0.609,
    gradientTransform: "matrix(192.1347 0 0 -233.9799 130310.2734 1436665.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A059FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#80008E",
      stopOpacity: 0.6
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "globe-shadow",
    style: {
      fill: "url(#globe-shadow_00000116931814237368977270000009253733651089027476_)"
    },
    d: " M256.804,216.282c-0.406,6.171-22.208,27.451-29.832,27.451c-70.544,0-81.995,42.669-81.995,42.669 c3.125,35.933,28.14,65.523,58.437,81.18c1.382,0.714,2.781,1.359,4.181,1.997c2.4,1.063,4.83,2.056,7.287,2.979 c10.388,3.678,21.269,5.776,32.28,6.226c123.644,5.799,147.599-147.814,58.369-192.422c22.851-3.974,46.57,5.216,59.816,14.521 c-21.69-37.898-62.194-63.468-108.697-63.468c-2.942,0-5.823,0.243-8.714,0.443c-24.885,1.711-48.678,10.879-68.276,26.31 c3.782,3.2,8.052,7.478,17.047,16.339C213.535,197.092,256.712,214.267,256.804,216.282L256.804,216.282z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ear_00000140711879134547457310000011691267121237655174_",
    cx: -667.2682,
    cy: 6207.8057,
    r: 2.9936,
    gradientTransform: "matrix(58.524 0 0 -58.732 39290.8906 364634.9062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#FFE200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#FF7232"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "ear",
    style: {
      fill: "url(#ear_00000140711879134547457310000011691267121237655174_)"
    },
    d: "M168.088,155.917 c1.728,1.115,3.442,2.25,5.142,3.406c-5.654-19.782-5.895-40.72-0.696-60.627c-25.484,11.604-45.306,29.946-59.716,46.142 C114.01,144.805,149.994,144.157,168.088,155.917L168.088,155.917z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "body_00000155128087859778917270000012667265649586154429_",
    cx: -678.6321,
    cy: 6131.3853,
    r: 1.8581,
    gradientTransform: "matrix(450.1546 0 0 -377.8801 305889 2316851.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#FF3346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#FF0D8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "body",
    style: {
      fill: "url(#body_00000155128087859778917270000012667265649586154429_)"
    },
    d: "M10.559,269.852 C29.7,382.965,132.239,469.327,248.632,472.623c107.728,3.049,176.555-59.479,204.982-120.481 c18.374-39.432,31.127-103.949,7.72-167.407l-0.008-0.027l-0.033-0.24c-0.026-0.184-0.041-0.293-0.037-0.233 c0,0.04,0.016,0.14,0.049,0.413c8.799,57.457-20.428,113.119-66.117,150.756l-0.137,0.323 c-89.027,72.488-174.219,43.735-191.468,31.965c-1.212-0.583-2.417-1.183-3.613-1.799c-51.904-24.804-73.346-72.091-68.749-112.644 c-43.827,0-58.771-36.964-58.771-36.964s39.349-28.056,91.209-3.655c48.031,22.599,93.139,3.657,93.144,3.655 c-0.092-2.015-43.269-19.19-60.101-35.774c-8.994-8.861-13.265-13.133-17.047-16.339c-2.052-1.733-4.197-3.353-6.426-4.852 c-1.702-1.154-3.416-2.289-5.142-3.406c-18.093-11.76-54.078-11.112-55.27-11.081h-0.115c-9.834-12.456-9.141-53.546-8.58-62.126 c-0.118-0.532-7.336,3.747-8.282,4.392c-8.678,6.194-16.791,13.145-24.244,20.769c-8.481,8.602-16.23,17.897-23.166,27.787 c0,0.012-0.007,0.027-0.011,0.039c0-0.013,0.007-0.027,0.011-0.039c-15.952,22.606-27.266,48.149-33.287,75.154 C15.024,211.345,6.213,249.87,10.559,269.852L10.559,269.852z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tail-flame_00000039826427530162296890000015335833112349427105_",
    cx: -714.7371,
    cy: 6125.2207,
    r: 3.6006,
    gradientTransform: "matrix(16.0845 151.871 153.0334 -15.9623 -925538.25 206256.9375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#FF3346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#FF0D8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "tail-flame",
    style: {
      fill: "url(#tail-flame_00000039826427530162296890000015335833112349427105_)"
    },
    d: "M343.858,171.97 c9.051,8.885,16.804,19.001,23.03,30.051c1.366,1.026,2.642,2.049,3.724,3.047c56.24,51.819,26.773,125.11,24.575,130.333 c45.689-37.636,74.916-93.299,66.117-150.756c-28.052-69.917-75.617-98.11-114.458-159.497c-1.961-3.104-3.928-6.216-5.844-9.497 c-0.975-1.675-1.887-3.387-2.731-5.132c-1.614-3.116-2.858-6.409-3.709-9.813c0.012-0.334-0.232-0.622-0.564-0.665 c-0.152-0.044-0.241-0.061-0.394-0.017c-0.035,0.012-0.159,0.07-0.196,0.084c-0.055,0.022-0.123,0.073-0.182,0.103 C323.78,5.073,266.743,94.865,343.858,171.97L343.858,171.97z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tail-small_00000004548343451468281620000017141347834490497209_",
    cx: -677.3172,
    cy: 6144.9336,
    r: 2.4609,
    gradientTransform: "matrix(195.1418 0 0 -191.7138 132414.375 1178169.875)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#FF9800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#FF3346"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#FF0D8A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "tail-small",
    style: {
      fill: "url(#tail-small_00000004548343451468281620000017141347834490497209_)"
    },
    d: "M370.612,205.068 c-1.083-0.998-2.359-2.021-3.724-3.047c-0.505-0.38-1-0.758-1.541-1.135c-13.246-9.305-36.965-18.495-59.816-14.521 c89.23,44.608,65.275,198.221-58.369,192.422c-11.011-0.449-21.892-2.548-32.28-6.226c-2.457-0.924-4.886-1.917-7.287-2.979 c-1.4-0.638-2.798-1.283-4.181-1.997c0.05,0.034,0.118,0.072,0.168,0.103c17.249,11.768,102.441,40.523,191.468-31.965l0.137-0.323 C397.385,330.182,426.851,256.889,370.612,205.068L370.612,205.068z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cheek-tufts_00000087374028332401807970000013052991941015548819_",
    cx: -675.5709,
    cy: 6150.4473,
    r: 3.232,
    gradientTransform: "matrix(178.5936 0 0 -159.7733 121018.7734 982806.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#FFF339"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#FF9800"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "cheek-tufts",
    style: {
      fill: "url(#cheek-tufts_00000087374028332401807970000013052991941015548819_)"
    },
    d: "M144.976,286.402 c0,0,11.451-42.669,81.995-42.669c7.626,0,29.429-21.28,29.832-27.451c0.404-6.171-45.11,18.944-93.144-3.655 c-51.86-24.401-91.209,3.655-91.209,3.655s14.944,36.964,58.771,36.964c-4.597,40.553,16.845,87.845,68.749,112.644 c1.16,0.554,2.25,1.16,3.441,1.692C173.117,351.925,148.101,322.335,144.976,286.402z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "overlay-yellow_00000062876945044336489620000004081868831753027202_",
    gradientUnits: "userSpaceOnUse",
    x1: -678.7422,
    y1: 6127.4795,
    x2: -679.3823,
    y2: 6126.7568,
    gradientTransform: "matrix(479.9996 0 0 -495.9987 326212 3039304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#FFF339",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#FFF339",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "overlay-yellow",
    style: {
      fill: "url(#overlay-yellow_00000062876945044336489620000004081868831753027202_)"
    },
    d: " M485.903,171.728c-10.782-25.935-32.619-53.934-49.767-62.783c13.956,27.36,22.034,54.806,25.12,75.289 c0,0.04,0.016,0.14,0.049,0.413c-28.052-69.918-75.617-98.111-114.458-159.498c-1.961-3.104-3.928-6.216-5.844-9.497 c-0.975-1.675-1.887-3.387-2.731-5.132c-1.614-3.116-2.858-6.409-3.709-9.813c0.012-0.334-0.232-0.622-0.564-0.665 c-0.152-0.044-0.241-0.061-0.394-0.017c-0.035,0.012-0.159,0.07-0.196,0.084c-0.055,0.022-0.253,0.135-0.276,0.149 c-64.085,38.36-83.261,103.826-85.204,137.604c2.89-0.2,5.772-0.443,8.714-0.443c46.506,0,87.01,25.569,108.697,63.468 c-13.246-9.305-36.965-18.495-59.816-14.521c89.23,44.608,65.275,198.221-58.369,192.422c-11.011-0.449-21.892-2.548-32.28-6.225 c-2.457-0.924-4.886-1.917-7.287-2.979c-1.4-0.638-2.798-1.283-4.181-1.997c0.05,0.034,0.118,0.072,0.168,0.103 c-1.212-0.583-2.417-1.183-3.613-1.799c1.16,0.554,2.25,1.16,3.442,1.692c-30.297-15.657-55.313-45.247-58.437-81.18 c0,0,11.451-42.669,81.995-42.669c7.626,0,29.429-21.28,29.832-27.451c-0.092-2.015-43.269-19.19-60.101-35.774 c-8.994-8.861-13.265-13.133-17.047-16.339c-2.052-1.733-4.197-3.353-6.426-4.852c-5.654-19.782-5.895-40.72-0.696-60.627 c-25.484,11.604-45.306,29.946-59.716,46.142h-0.115c-9.834-12.456-9.141-53.546-8.58-62.126c-0.118-0.532-7.336,3.747-8.282,4.392 c-8.678,6.194-16.791,13.144-24.244,20.769c-8.478,8.602-16.225,17.895-23.159,27.784c0,0.012-0.007,0.027-0.011,0.039 c0-0.013,0.007-0.027,0.011-0.039c-15.952,22.606-27.266,48.149-33.287,75.154c-0.119,0.538-0.219,1.095-0.334,1.637 c-0.467,2.184-2.566,13.268-2.859,15.645c-0.023,0.183,0.022-0.182,0,0c-1.915,11.453-3.136,23.011-3.658,34.612 c0,0.423-0.026,0.842-0.026,1.267c0,136.989,111.071,248.042,248.077,248.042c122.7,0,224.579-89.072,244.524-206.07 c0.42-3.175,0.757-6.367,1.127-9.57C506.924,253.83,501.446,209.118,485.903,171.728z M461.293,184.467 c0.012,0.088,0.028,0.18,0.041,0.267l-0.008-0.027L461.293,184.467z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.61c9d6f03d694766efcd3ec44c4ec2c7.svg";
export { ForwardRef as ReactComponent };